var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBoxCheckSolid = function SvgBoxCheckSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "M16.25 2.5H3.75A1.25 1.25 0 0 0 2.5 3.75v12.5a1.25 1.25 0 0 0 1.25 1.25h12.5a1.25 1.25 0 0 0 1.25-1.25V3.75a1.25 1.25 0 0 0-1.25-1.25m-10 13.125a.62.62 0 0 1-.442-.183l-1.25-1.25a.625.625 0 0 1 .884-.884l.808.808 2.683-2.683a.625.625 0 0 1 .884.884l-3.125 3.125a.63.63 0 0 1-.442.183M15.625 15a.624.624 0 0 1-.625.625h-4.375a.624.624 0 1 1 0-1.25h3.75v-8.75h-8.75v5a.625.625 0 1 1-1.25 0V5A.625.625 0 0 1 5 4.375h10a.625.625 0 0 1 .625.625z"
  })));
};
export default SvgBoxCheckSolid;